import { createFileRoute } from "@tanstack/react-router";

import { HubIndexPage, hubQuery } from "@/components/hubs/HubIndexPage";
import { buildHreflangLinks, buildLocaleMeta } from "@/lib/i18n-paths";

const PATH = "/saunas";

export const Route = createFileRoute("/saunas/")({
  loader: ({ context }) => context.queryClient.ensureQueryData(hubQuery("saunas")),
  head: ({ loaderData }) => {
    const hub = (loaderData as any)?.hub;
    const places = ((loaderData as any)?.places ?? []) as { name: string; slug: string }[];
    const url = `https://whatfinland.com${PATH}`;
    const title = hub?.seo_title || "Public saunas in Finland — where to sauna | what Finland";
    const desc = hub?.seo_description || "Finland's public saunas: sauna type, swim, city, opening details and booking.";
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:type", content: "website" },
        { property: "og:url", content: url },
        ...buildLocaleMeta("en"),
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...buildHreflangLinks(PATH)],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ItemList",
            name: "Public saunas in Finland",
            url,
            numberOfItems: places.length,
            itemListElement: places.map((p, i) => ({
              "@type": "ListItem",
              position: i + 1,
              name: p.name,
              url: `${url}/${p.slug}`,
            })),
          }),
        },
      ],
    };
  },
  component: () => <HubIndexPage slug="saunas" locale="en" />,
});
